import React, { useEffect } from "react";
import "./HomeZoomPaneModal.css";

const HomeZoomPaneModal = ({
  isOpen,
  onClose,
  title,
  description,
  children,
}) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-header-left">
            <button className="modal-close" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="modal-header-right">
            <h1 style={{ fontWeight: "bold" }}>{title}</h1>
            <h4 style={{ color: "grey", direction: "rtl" }}>{description}</h4>
          </div>
        </div>
        <div
          className="modal-body"
          style={{ justifyItems: "stretch", alignItems: "center" }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default HomeZoomPaneModal;
